import React, { useState, useEffect } from 'react'
import { Card, CardBody, CardHeader, Col, Row, Spinner } from 'reactstrap'

import FaqContentWidget from './partials/FaqContentWidget'
import FaqDetailsWidget from './partials/FaqDetailsWidget'
import FaqDocumentWidget from './partials/FaqDocumentWidget'

import ModelCategoriesWidget from '../Categories/ModelCategoriesWidget'

import { getFaq } from './services'
import { handleError } from '../../helpers'

export default function FaqProfile(props) {
	const id = props.match.params.id
	const [faq, setFaq] = useState(null)
	const [reload, setReload] = useState(true)

	useEffect(() => {
		reload && getFaq(id, {
			include: 'categories,document'
		})
			.then(res => setFaq(res.data.data))
			.catch(error => handleError(error))
			.finally(() => setReload(false))
	}, [ reload, id ])

	if(!faq) return <Spinner />

	const morphProps = {
		model: faq,
		modelType: "faq",
		reload: () => setReload(true)
	}

	return (
		<React.Fragment>
			<Row>
				<Col md="4">
					<Card>
						<CardHeader>
							<h6 className='mb-0'>Detalles Generales</h6>
						</CardHeader>
						<CardBody>
							<FaqDetailsWidget faq={faq} reload={() => setReload(true)} />
						</CardBody>
					</Card>
					<Card>
						<CardHeader>
							<h6 className='mb-0'>Documento Asociado</h6>
						</CardHeader>
						<CardBody>
							<FaqDocumentWidget faq={faq} reload={() => setReload(true)} />
						</CardBody>
					</Card>
					<Card>
						<CardHeader>
							<h6 className='mb-0'>Categorías de Preguntas</h6>
						</CardHeader>
						<CardBody>
							<ModelCategoriesWidget {...morphProps} />
						</CardBody>
					</Card>
				</Col>
				<Col>
					<Card>
						<CardHeader>
							<h6 className='mb-0'>Datos de la Pregunta</h6>
						</CardHeader>
						<CardBody>
							<FaqContentWidget faq={faq} />
						</CardBody>
					</Card>
				</Col>
			</Row>
		</React.Fragment>
	)
}